export const refreshTotal = async (ctx,newOrderModel, index = null) => {
        // const { action, view } = this.props;
        // const { editMode } = this.state
        // let newView = newOrderModel.newView || '';

        // if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || isMarketingDoc(newOrderModel?.ObjType)) {
        //     // Se requiere el siguiente orden para calcular percepciones
        //     newOrderModel = this.getTotals(newOrderModel);
        //     newOrderModel = this.calculatePerception(newOrderModel);
        //     newOrderModel = this.getTotals(newOrderModel, true);
        // } else {
        //     // newOrderModel = this.calculatePerception(newOrderModel);
        //     if (index || index === 0) {


        //         newOrderModel.Items[index].Price = parseFloat(newOrderModel.Items[index].HomePrice).toFixed(priceDecimalPrecision) * (newOrderModel.Items[index].BaseQty || 1);
        //         if (newOrderModel.Items[index]?.Gallons) { // Precio determinado por conversion a galones
        //             newOrderModel.Items[index].Price = Number(newOrderModel.Items[index].Quantity) > 0 ? parseFloat(Number(newOrderModel.Items[index].U_RS_TOTALGL || 0) / Number(newOrderModel.Items[index].Quantity))?.toFixed(priceDecimalPrecision) : 0
        //         }
        //         let discount = newOrderModel.Items[index].Price * newOrderModel.Items[index].Quantity * (newOrderModel.Items[index].DiscountPercent / 100);
        //         newOrderModel.Items[index].Discount = discount || 0;

        //         let impuesto = parseFloat(((newOrderModel.Items[index].Price * newOrderModel.Items[index].Quantity - newOrderModel.Items[index].Discount)).toFixed(2)) * (newOrderModel.Items[index].TaxeRate / 100);
        //         newOrderModel.Items[index].TaxeResult = impuesto.toFixed(2);
        //         let total = 0;
        //         total = (newOrderModel.Items[index].Price / newOrderModel.ChangeRate) * newOrderModel.Items[index].Quantity - (newOrderModel.Items[index].Discount / newOrderModel.ChangeRate);
        //         total = calcultateOperation(newOrderModel.Items[index], newOrderModel)?.totalHeader ?? total

        //         newOrderModel.Items[index].Total = total;
        //         const priceWithTax = (newOrderModel?.Items?.[index]?.Price || 0) * (1 + ((newOrderModel?.Items?.[index]?.TaxeRate || 0) / 100))
        //         newOrderModel.Items[index].DiscountedPrice = priceWithTax - ((newOrderModel?.Items?.[index]?.DiscountPercent || 0) * priceWithTax / 100)


        //     } else {

        //         newOrderModel.Items.map(item => {
        //             item.Price = Number(Number(item.HomePrice)).toFixed(priceDecimalPrecision) * (item.BaseQty || 1);
        //             if (item.Gallons) { // Precio determinado por conversion a galones
        //                 item.Price = Number(item.Quantity) > 0 ? parseFloat(Number(item.U_RS_TOTALGL || 0) / Number(item.Quantity))?.toFixed(priceDecimalPrecision) : 0
        //             }
        //             let discount = item.Price * item.Quantity * (item.DiscountPercent / 100);
        //             item.Discount = discount || 0;

        //             let impuesto = item.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(item.ImpuestoRow / newOrderModel.ChangeRate) : round(parseFloat(((item.Price * item.Quantity - item.Discount)).toFixed(2)) * (item.TaxeRate / 100));
        //             item.TaxeResult = impuesto.toFixed(2);
        //             let total = 0;
        //             total = (item.Price / newOrderModel.ChangeRate) * item.Quantity - (item.Discount / newOrderModel.ChangeRate);
        //             total = calcultateOperation(item, newOrderModel)?.totalHeader ?? total
        //             item.Total = item.ifChangeUomCode ? round(total) : item.LineTotal && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(item.LineTotal / newOrderModel.ChangeRate) : round(total);
        //             if (this.props.newOrderModel.OriginDocumentCreate && this.props.newOrderModel.OriginDocumentCreate === 'deliveries' && this.props.view === 'invoiceReserve') {
        //                 item.Total = round(item.LineTotal / newOrderModel.ChangeRate);
        //             }
        //             const priceWithTax = (item?.Price || 0) * (1 + ((item?.TaxeRate || 0) / 100))
        //             item.DiscountedPrice = priceWithTax - ((item?.DiscountPercent || 0) * priceWithTax / 100)
        //         });

        //     }



        //     let subTotal = 0;
        //     let impuestos = 0;
        //     let discount = 0;
        //     let total = 0;
        //     let weightTotal = 0;
        //     let taxesRate = 0;
        //     let subTotalTaxOnly = 0;
        //     let subTotalTaxStatus = 0;


        //     for (let index = 0; index < newOrderModel.Items.length; index++) {
        //         const item = newOrderModel.Items[index];
        //         let discount = parseFloat(item.Total * ((newOrderModel.DiscountPercent || 0) / 100)).toFixed(2);

        //         let impuesto = item.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true && action === 1 ? round(item.ImpuestoRow / newOrderModel.ChangeRate) : round(parseFloat(((item.Total - discount)).toFixed(2)) * (item.TaxeRate / 100));
        //         item.TaxeResult = Number(Number(impuesto)).toFixed(2);
        //         const taxNotRounded = item.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true && action === 1 ? (item.ImpuestoRow / newOrderModel.ChangeRate) : parseFloat(((item.Total - discount)) * (item.TaxeRate / 100));

        //         subTotalTaxStatus += item.TaxStatus == 'N' ? Number(taxNotRounded) : 0
        //         subTotalTaxOnly += item.TaxOnly == 'Y' ? Number(item.Total) : 0
        //         subTotal += parseFloat(Number(item.Total).toFixed(2));
        //         impuestos += parseFloat(Number(item.TaxeResult).toFixed(2));
        //         weightTotal += Number(item.Weight) * Number(item.Quantity);
        //         taxesRate += (item.TaxeRate / 100); // part of new code DpmAddition
        //     }
        //     taxesRate = taxesRate / newOrderModel.Items.length ?? 1;
        //     // last code before DpmAdding in BRANCH
        //     // let iva = (impuestos * 100) / subTotal;
        //     // let subtotalDpm = subTotal - newOrderModel.DpmAmnt;
        //     // discount = subtotalDpm * (newOrderModel.DiscountPercent / 100);
        //     // impuestos = subtotalDpm * (iva / 100);
        //     // total = parseFloat(parseFloat(subtotalDpm).toFixed(2) - parseFloat(discount).toFixed(2)) + parseFloat(parseFloat(impuestos).toFixed(2));

        //     newOrderModel.DpmAmnt = Number(newOrderModel.DownPaymentAmount) ?? 0.0;
        //     subTotal = subTotal - newOrderModel.DpmAmnt;
        //     discount = subTotal * (newOrderModel.DiscountPercent / 100);
        //     impuestos = subTotal * taxesRate;
        //     impuestos = Math.round(impuestos * 100) / 100
        //     total = parseFloat(parseFloat(subTotal).toFixed(2) - parseFloat(discount).toFixed(2)) + parseFloat(parseFloat(impuestos).toFixed(2));
        //     subTotal = subTotal - subTotalTaxOnly
        //     total -= subTotalTaxOnly + subTotalTaxStatus
        //     total = Math.round(total * 100) / 100
        //     const restaPrecision = (Math.round(impuestos * 1000) - Math.round(subTotalTaxStatus * 1000)) / 1000;
        //     impuestos = Math.round(restaPrecision * 100) / 100;

        //     newOrderModel.Subtotal = Number(subTotal.toFixed(2));
        //     newOrderModel.Discount = Number(discount.toFixed(2));
        //     newOrderModel.Taxes = Number(impuestos.toFixed(2));
        //     newOrderModel.Total = Number(total.toFixed(2));
        //     newOrderModel.WeightTotal = weightTotal;
        // }

        // if (newOrderModel.RateAmnt) {
        //     newOrderModel.TotalRetenido = Number((newOrderModel.Subtotal * newOrderModel.RateAmnt).toFixed(2));
        //     newOrderModel.Total = newOrderModel.Total - newOrderModel.TotalRetenido;
        // }

        // //#region DETRACCIONES
        // if (newOrderModel.isPurchaseDocument && (newOrderModel.DetraccionVista || newView === 'PurchaseOrder')) {
        //     let isBPDetraccion = newOrderModel.U_FMB_BP_Detra === 'Y';
        //     let isDetraccion = false;

        //     const isPurchaseInvoice = newView === 'purchaseInvoice' || view === 'purchaseInvoice';
        //     const isPurchaseOrder = newView === 'PurchaseOrder';
        //     const isCopy = newOrderModel.isSelectToActive || newOrderModel.isSelectOfActive; // Se copia el documento
        //     const noCopy = !newOrderModel.isSelectToActive && !newOrderModel.isSelectOfActive; // No se esta copiando el documento
        //     const isPurchaseInvoiceOnlyOpen = isPurchaseInvoice && action === 2 && !editMode;
        //     const isEdit = Number(action) === 2 && editMode;
        //     const isCreate = Number(action) === 1;

        //     if (isPurchaseInvoiceOnlyOpen && newOrderModel.U_STR_AfctoDtr === 'Y') { // Mostrar la información con la que ya se creo la factura de proveedor
        //         newOrderModel.Total = Number((Number(newOrderModel.Total) - Number(newOrderModel.U_RS_MONDET || 0)).toFixed(2));
        //     } else if ((isCreate || isEdit) &&
        //         isBPDetraccion &&
        //         (
        //             (noCopy) ||
        //             (isCopy && (newOrderModel.existsDetraccion || isPurchaseOrder))
        //         )
        //     ) {
        //         if (noCopy || (isCopy && isPurchaseOrder)) { // Mientras sea un docuento sin copiar se evaluan detracciones
        //             const totalConvert = calcultateOperationHeader(newOrderModel);
        //             const detraccion = this.checkDetraccion(newOrderModel.Items, Number(totalConvert?.totalLocal ?? newOrderModel?.Total ?? 0) || 0);
        //             isDetraccion = detraccion?.isDetraccion || 'N';

        //             newOrderModel.U_STR_AfctoDtr = isDetraccion;
        //             newOrderModel.U_STR_TasaDTR = Number(detraccion?.Rate || 0);
        //             newOrderModel.U_STR_CodBnSs = detraccion?.tasa || '';
        //         }

        //         const U_RS_MONDET = Number(newOrderModel.Total || 0) * (newOrderModel.U_STR_TasaDTR / 100);
        //         newOrderModel.U_RS_MONDET = Number(U_RS_MONDET || 0).toFixed(2);
        //         if (newView === 'purchaseInvoice') { // Solo en factura de proveedor se muestra el monto total menos el monto de la detracción
        //             newOrderModel.Total = Number((Number(newOrderModel.Total) - Number(newOrderModel.U_RS_MONDET)).toFixed(2));
        //         }
        //     } else if ((isCreate || isEdit) && noCopy) { // No aplica detracciones
        //         newOrderModel.U_FMB_BP_Detra = 'N';
        //         newOrderModel.U_STR_AfctoDtr = 'N';
        //         newOrderModel.U_STR_TasaDTR = 0;
        //         newOrderModel.U_STR_CodBnSs = '';
        //         newOrderModel.U_RS_MONDET = 0;
        //     }
        // }
        // //#endregion DETRACCIONES

        // //PAGOS
        // newOrderModel.totalDocumento = 0;
        // newOrderModel.totalPago = 0;
        // newOrderModel.totalCreditPerception = 0;
        // newOrderModel.CheckSum = 0;

        // const isAccountPayment = newOrderModel.isAccountPayment;

        // newOrderModel.ItemsPayments.map(item => {
        //     newOrderModel.totalDocumento += Number(item.pastDueBalance); //item.total
        //     newOrderModel.totalPago += isAccountPayment ? Number(item.PriceFormat || 0) : Number(item.totalPago);
        //     if (item.TransId) { // Este no debe de venir en detalle para que no se sume (Por eso vienen registros extras con el valor)
        //         newOrderModel.totalCreditPerception += Number(item.U_PRC_IMP) || 0;
        //     }
        // });

        // newOrderModel.CheckList.map(item => {
        //     newOrderModel.CheckSum += Number(item.CheckSum);
        // });

        // if (newOrderModel.PayNoDoc) {
        //     newOrderModel.totalDocumento = newOrderModel.NoDocSum;
        // }


        // newOrderModel.totalRecibido = Number(newOrderModel.CashSum) + Number(newOrderModel.CreditSum) + Number(newOrderModel.CheckSum) + Number(newOrderModel.TrsfrSum);

        // if (newOrderModel.DocCur != newOrderModel.DocCurDocumentsPayment && !isAccountPayment) {
        //     let localCurrency = CURRENCY;
        //     let rate = 1;
        //     if (localCurrency == newOrderModel.DocCur) {
        //         newOrderModel.Currencies.map(currency => {
        //             if (newOrderModel.DocCurDocumentsPayment == currency.CurrCode) {
        //                 rate = currency.Rate || 1;
        //             }
        //         });

        //         newOrderModel.totalPago = Number((newOrderModel.totalPago * rate).toFixed(2));
        //     } else {
        //         newOrderModel.Currencies.map(currency => {
        //             if (newOrderModel.DocCur == currency.CurrCode) {
        //                 rate = currency.Rate || 1;
        //             }
        //         });
        //         newOrderModel.totalPago = Number((newOrderModel.totalPago / rate).toFixed(2));
        //     }
        // }

        // newOrderModel.totalPago = Number((newOrderModel.totalPago).toFixed(2));
        // //#region CREDIT PERCEPTIONS
        // newOrderModel.totalPago = Number((Number(newOrderModel.totalPago) + Number(newOrderModel.totalCreditPerception))?.toFixed(2));
        // //#endregion CREDIT PERCEPTIONS
        // newOrderModel.totalRestante = newOrderModel.totalPago - newOrderModel.totalRecibido;
        // // newOrderModel.WeightTotal = weightTotal;

        // //#region RETENCIONES
        // newOrderModel = await this.checkWithHolding(newOrderModel); // Se coloca hasta aqui por que ocupa totalPago
        // //#region RETENCIONES
        // this.refreshModel(newOrderModel);

    };